export const PAYMENT_CONTEXT_KEY = "tarh_payment_ctx";

export const storePaymentContext = (context = {}) => {
  try {
    sessionStorage.setItem(PAYMENT_CONTEXT_KEY, JSON.stringify(context));
  } catch (_) {
    // ignore
  }
};

export const readPaymentContext = () => {
  try {
    const cached = sessionStorage.getItem(PAYMENT_CONTEXT_KEY);
    return cached ? JSON.parse(cached) : null;
  } catch (_) {
    return null;
  }
};

export const clearPaymentContext = () => {
  try {
    sessionStorage.removeItem(PAYMENT_CONTEXT_KEY);
  } catch (_) {
    // ignore
  }
};
